import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import SortableHeaderColumn from 'garaje/components/sortable-header-column';
import type Questionnaire from 'garaje/models/questionnaire';

import Row from './table/row';

interface VisitorsQuestionnairesListTableSignature {
  Args: {
    canDeleteQuestionnaires: boolean;
    canUpdateQuestionnaires: boolean;
    changeSort: (sortField: string, sortDirection: 'asc' | 'desc') => void;
    deleteQuestionnaire: (questionnaire: Questionnaire) => void;
    questionnaires: Questionnaire[];
    showRoute: string;
    sort: string;
  };
  Blocks: {
    footer?: [number];
  };
  Element: HTMLTableElement;
}

export default class VisitorsQuestionnairesListTable extends Component<VisitorsQuestionnairesListTableSignature> {
  get sortBy(): string {
    const sort = this.args.sort;
    return sort.startsWith('-') ? sort.slice(1) : sort;
  }

  get sortDirection(): 'asc' | 'desc' {
    return this.args.sort.startsWith('-') ? 'desc' : 'asc';
  }

  <template>
    <table data-test-questionnaires-list ...attributes>
      <thead>
        <tr class="text-carbon-50 text-sm">
          <th class="border-b w-1/5">
            <SortableHeaderColumn
              @name="Name"
              @isActive={{eq this.sortBy "title"}}
              @sortDirection={{this.sortDirection}}
              @sortField="title"
              @sortAction={{@changeSort}}
            />
          </th>
          <th class="border-b w-40">Number of questions</th>
          <th class="border-b">Sign-in flows applied</th>
          <th class="border-b w-1/6">Last updated</th>
          <th class="border-b w-4"></th>
        </tr>
      </thead>

      <tbody>
        {{#each @questionnaires as |questionnaire|}}
          <Row
            @canDeleteQuestionnaires={{@canDeleteQuestionnaires}}
            @canUpdateQuestionnaires={{@canUpdateQuestionnaires}}
            @deleteQuestionnaire={{@deleteQuestionnaire}}
            @questionnaire={{questionnaire}}
            @showRoute={{@showRoute}}
          />
        {{/each}}
      </tbody>

      {{#if (has-block "footer")}}
        <tfoot>
          {{! Pass number of columns to footer so it can span the whole table; future enhancements may make the column list dynamic }}
          {{yield 5 to="footer"}}
        </tfoot>
      {{/if}}
    </table>
  </template>
}
